import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import { AuthenticationService } from '@src/app/_services/authentication.service';
import { AsyncPipe, NgForOf, NgIf, registerLocaleData } from '@angular/common';

import moment from 'moment';
import localeCs from '@angular/common/locales/cs';
import { User } from '@src/app/_models/user/user';
import { MessageService } from '@src/app/_services/message.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { Notifications } from '@src/app/_models/notification/notification';
import { NotificationService } from '@src/app/features/notifications/notification.service';
import { ButtonPropsModel, DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';

moment.updateLocale('cs', { workingWeekdays: [1, 2, 3, 4, 5] });
registerLocaleData(localeCs);

@UntilDestroy()
@Component({
    selector: 'app-notification-list',
    templateUrl: './notification-list.component.html',
    styleUrls: ['./notification-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogModule, AsyncPipe, InfiniteScrollDirective, NgIf, NgForOf],
})
export class NotificationListComponent implements OnInit {
    // Variables
    currentUser: User | null;

    // Loaders
    loadingNotification = true;

    limit = 20;

    notificationsOld$: Observable<Notifications[] | undefined>;

    notificationsNew$: Observable<Notifications[] | undefined>;

    buttonsReadAll: ButtonPropsModel[] = [
        {
            click: (): void => {
                this.allReaded();
            },
            isFlat: false,
            buttonModel: {
                content: 'OK',
                cssClass: 'e-success e-outline',
            },
        },
        {
            click: (): void => {
                this.confirmationRadAll.hide();
            },
            buttonModel: {
                content: 'ZRUŠIT',
                cssClass: 'e-danger e-outline',
            },
        },
    ];

    @ViewChild('confirmationRadAll') confirmationRadAll: DialogComponent;

    constructor(
        private readonly ref: ChangeDetectorRef,
        private readonly messages: MessageService,
        private readonly notificationService: NotificationService,
        private readonly authenticationService: AuthenticationService
    ) {
        this.currentUser = this.authenticationService.currentUserValue;
    }

    ngOnInit(): void {
        this.notificationsOld$ = this.notificationService.notificationsOld$;

        this.notificationsNew$ = this.notificationService.notificationsNew$;
    }

    onScroll(): void {
        this.limit = this.limit + 20;
        console.info('load more  old notifications');
    }

    allAsRead(): void {
        this.confirmationRadAll.content =
            'Opravdu chcete všechny nepřečtené notifikace označit jako přečtené?';
        this.confirmationRadAll.show();
    }

    allReaded(): void {
        if (!this.currentUser?.id) {
            return;
        }

        this.loadingNotification = true;

        this.notificationService.allAsRead(this.currentUser.id).subscribe(
            result => {
                if (result) {
                    this.loadingNotification = false;

                    this.ref.markForCheck();
                } else {
                    const body = 'Zkuste to znovu později';
                    const options = { progressBar: true, timeOut: 5000 };

                    this.messages.showError('Chyba během úpravy szavů notifikací', body, options);
                    this.loadingNotification = false;
                    this.ref.markForCheck();
                }
            },
            error => {
                console.error(error);

                const body = 'Zkuste to znovu později';
                const options = { progressBar: true, timeOut: 5000 };

                this.messages.showError('Chyba během úpravy szavů notifikací', body, options);
                this.loadingNotification = false;
                this.ref.markForCheck();
            }
        );
    }

    trackNewNotifID(index: number, notifications: Notifications): number {
        return notifications.id;
    }

    trackOldNotifID(index: number, notifications: Notifications): number {
        return notifications.id;
    }
}
